import React, { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import { SearchOutlined } from "@mui/icons-material";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import toast from "react-hot-toast";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import axios from "../../API/axios";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import BlockSharpIcon from "@mui/icons-material/BlockSharp";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";

const JobList = () => {
  const sessionId = localStorage.getItem("sessionId");
  // ..................................CloneFolder Start..................................
  const [cloneId, setCloneId] = useState("");
  const [showCloneFolder, setShowCloneFolder] = useState(false);
  const handleCloneFolderClose = () => {
    setShowCloneFolder(false);
  };

  const CloneFolder = async () => {
    const body = {
      sessionId: sessionId,
      jobId: cloneId,
    };
    try {
      const response = await axios.post("/JobAction/CloneJob", body);
      toast.success(response.data.message);
      getAlljobList();

      handleCloneFolderClose();
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error(error.response.data.message);
    }
  };
  // ..................................CloneFolder End...................................
  //................................. Delete job Start................................. //

  const [jobid, setJobId] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const DeleteJob = async () => {
    const responsedata = {
      sessionId: sessionId,
      jobId: jobid,
    };

    try {
      await axios
        .delete("/JobAction/DeleteJob", {
          data: responsedata,
        })
        .then((resData) => {
          toast.success(resData.data.message);
          setShowModal(false);
          getAlljobList();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        toast.warning(e.response.data.message);

        setShowModal(false);
      } else {
        toast.error(e.response.data.message);
      }
    }
  };

  const handleConfirmDelete = () => {
    DeleteJob();
    setShowModal(false);
  };

  //.................................. Delete job End  ................................... //

  //.................................. Enable Job End  ................................... //
  const EnableJob = async () => {
    const data = {
      sessionId: sessionId,
      jobId: jobid,
    };

    try {
      await axios.post("/JobAction/EnableJob", data).then((resData) => {

        toast.success(resData.data.message);
        getAlljobList();

      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        toast.warning(e.response.data.message);
      } else {
        toast.error(e.response.data.message);
      }
    }
  };

  //.................................. Enable Job End  ................................... //

  //.................................. Disable Job End  ................................... //
  // const DisableJob = async () => {
  //   const data = {
  //     sessionId: sessionId,
  //     jobId: jobid,
  //   };

  //   try {
  //     await axios.post("/JobAction/DisableJob", data).then((resData) => {
  //       toast.success(resData.data.message);
  //       getAlljobList();
  //     });
  //   } catch (e) {
  //     if (e.response && e.response.status === 404) {
  //       toast.warning(e.response.data.message);
  //     } else {
  //       toast.error(e.response.data.message);
  //     }
  //   }
  // };
  const DisableJob = async (id) => {
    // setLoading(true); 
    try {
      const response = await axios.post(`/JobAction/DisableJob`, {
        sessionId: sessionId,
        jobId: id,
      });
      console.log("disable", response);
      toast.success(response.data.message);
       getAlljobList();

    } catch (error) {
      console.error("Error unsaving job:", error);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      // setLoading(false);
    }
  };

  //.................................. Disable Job End  ................................... //

  const userUID = localStorage.getItem("userUID");

  // ...............................All Job List Start.......................................
  const [jobList, setjobList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState([]);

  const getAlljobList = (page) => {
    try {
      const data = {
        pageNumber: page,
        pageSize: 5,
      };

      axios
        .post(`/Job/GetAllByCompany/${userUID}?Search=${search}`, data)
        .then((response) => {
          const res = response.data.responseData.jobsList;
          setjobList(res);
          console.log("list", res);

        })
        .catch((err) => {
          console.error("Error fetching jobs:", err);
        });
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  useEffect(() => {
    getAlljobList(currentPage);
  }, [search]);
  // ...............................All Jobs List End.......................................

  const columns = [
    {
      name: "Title",
      center: true,
      sortable: true,
      minWidth: "200px",
      selector: (row) => row.title,
    },
    {
      name: "Company",
      center: true,
      sortable: true,
      minWidth: "200px",
      selector: (row) => row.compName,
    },
    {
      name: "City",
      center: true,
      sortable: true,
      minWidth: "200px",
      selector: (row) => row.cityName,
    },
    {
      name: " Designation",
      center: true,
      sortable: true,
      minWidth: "200px",
      selector: (row) => row.designationName,
    },
    {
      name: "Action",
      center: true,
      minWidth: "200px",
      cell: (row) => (
        <>
          <Link to={`/editJob/${row.jobId}`}>
            <EditSharpIcon
              style={{ cursor: "pointer", color: "black" }}
              className="joblist-eye-icon Dark-icon-color"
            />
          </Link>
          <Link to={`/jobDetails/${row.jobId}`}>
            <VisibilitySharpIcon
              style={{ cursor: "pointer", color: "black" }}
              className="ms-2 joblist-eye-icon Dark-icon-color"
            />
          </Link>

          <Dropdown className="view-job-dropdown">
            <Dropdown.Toggle as="span" className="icon-togg">
              <MoreHorizSharpIcon className="ms-2" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                href="#"
                onClick={() => {
                  setShowCloneFolder(!showCloneFolder);
                  setCloneId(row.jobId);
                }}
              >
                <FileCopyIcon
                  style={{ cursor: "pointer" }}
                  className="material-symbols-sharp joblist-eye-icon me-2 mt-0"
                />
                Clone Job
              </Dropdown.Item>
              <Dropdown.Item
                href="#"
                onClick={() => {
                  handleShowModal();
                  setJobId(row.jobId);
                }}
              >
                <DeleteOutlineSharpIcon
                  style={{ cursor: "pointer" }}
                  className="material-symbols-sharp joblist-eye-icon me-2 mt-0"
                />
                Delete
              </Dropdown.Item>

              {row.status === 1 ? (
                <Dropdown.Item
                  href="#"
                  onClick={() => {
                    DisableJob(row.jobId);
                    // setJobId(row.jobId);
                  }}
                >
                  <BlockSharpIcon
                    style={{ cursor: "pointer" }}
                    className="material-symbols-sharp joblist-eye-icon me-2 mt-0"
                  />
                  Disable
                </Dropdown.Item>
              ) : (
                <Dropdown.Item
                  href="#"
                  onClick={() => {
                    EnableJob();
                    setJobId(row.jobId);
                  }}
                >
                  <CheckCircleOutlineSharpIcon
                    style={{ cursor: "pointer" }}
                    className="material-symbols-sharp joblist-eye-icon me-2"
                  />
                  Enable
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </>
      ),
    },
  ];

  return (
    <>
      <section className="pricing-section-three container jobapplication view-job-style  pt-5">
        <div className="row">
          <div className="mb-1 col-6">
            <h6 className="orange-title">
              <span className="orange-box me-2"></span>
              View Jobs{" "}
            </h6>
          </div>
          <div className="mb-1 col-6 text-start"></div>
        </div>
        <div className="container st3">
          <div className="row">
            <div className="col-lg-12">
              <div class="wd-findjob-filer">
                <div className="form-group-1 ps-1 khojSearch d-flex align-items-center mb-2">
                  <SearchOutlined className="searchIcon" />
                  <input
                    type="text"
                    className="input-filter-search"
                    placeholder="Search"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>

              <div className="scroll-react-dataTable">

                <div className="react-dataTable">
                  <DataTable
                    noHeader
                    pagination
                    columns={columns}
                    paginationPerPage={5}
                    className="react-dataTable"
                    sortIcon={<ChevronDown size={10} />}
                    paginationDefaultPage={currentPage}
                    onChangePage={(page) => {
                      console.log("onChangePage argument:", page); // Debugging
                      setCurrentPage(page);
                      getAlljobList(page);
                    }}
                    data={jobList}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*...... Delete Education modal  Start................*/}

      <Modal show={showCloneFolder} onHide={handleCloneFolderClose} centered>
        <Modal.Header>
          <Modal.Title> Clone Job</Modal.Title>
          <CloseSharpIcon
            className="pointer"
            onClick={handleCloneFolderClose}
          />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Do you want to Clone this Job ?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={CloneFolder} className="btn btn-danger me-2">
            Confirm
          </button>
          <button
            onClick={handleCloneFolderClose}
            className="btn btn-secondary"
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
      {/*...... Delete Education modal  End.................*/}
      {/*......  CloneJob modal  End*/}

      {/* .......................Delete modal start....................  */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header>
          <Modal.Title>Confirm Delete</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Are you sure you want to delete this Job</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleConfirmDelete} className="btn btn-danger me-2">
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
      {/* .......................Delete modal end......................  */}
    </>
  );
};

export default JobList;
